import { ProgramsContainer, Hero, ProgramSection, ProgramCard } from './styles';
import { FaBalanceScale, FaLeaf, FaLaptop } from 'react-icons/fa';

const Programs = () => {
  const programs = [
    {
      icon: <FaBalanceScale />,
      title: "Programme de la Gouvernance Locale, Démocratie et Genre (PROGOL-DG)",
      description: `Ce programme vise la participation, la responsabilisation et la transparence dans la gouvernance locale. Il promeut la démocratie participative, l’égalité des chances et l’accès à l’information, tout en renforçant les capacités des communautés de base et des acteurs locaux.`,
      activities: [
        "Budget participatif",
        "Justice des taxes et audit social",
        "Accès à l’information",
        "Gouvernance et élections (participation politique de la femme, égalité des chances)",
        "Services sociaux de base (éducation, santé, eau, hygiène, assainissement)",
        "Structuration communautaire, renforcement des capacités et accompagnement"
      ]
    },
    {
      icon: <FaLeaf />,
      title: "Programme Environnement, Ressources Naturelles et Développement Durable (ERENA-DD)",
      description: `Ce programme œuvre pour une gestion durable et équitable des ressources naturelles, en impliquant les communautés locales dans la prise de décision et la défense de leurs droits. Il soutient le développement durable, le partage d’informations et le plaidoyer pour un cadre politique adapté.`,
      activities: [
        "Appui à l’implication des communautés locales dans la gestion des ressources naturelles",
        "Participation et partage d’informations sur le processus REDD+",
        "Plaidoyer pour un cadre politique et juridique adapté",
        "Renforcement des capacités des ETD dans la gestion de l’environnement",
        "Appui aux actions de développement durable et alternatives"
      ]
    },
    {
      icon: <FaLaptop />,
      title: "Centre Multimédias pour Jeunes (CMJ)",
      description: `Le CMJ est un espace dédié à la formation, la recherche, la publication et aux services pour les jeunes. Il favorise l’accès à l’information, le développement des compétences numériques et l’engagement citoyen des jeunes.`,
      activities: [
        "Formations multimédias",
        "Recherche et publication",
        "Services numériques pour les jeunes",
        "Promotion de l’engagement citoyen"
      ]
    }
  ];

  return (
    <ProgramsContainer>
      <Hero>
        <h1>Nos Programmes</h1>
        <p>
          Nous prônons la participation, le renforcement des capacités et la responsabilisation des communautés de base et acteurs locaux pour la pérennisation de nos actions. Nos programmes intègrent la participation, la responsabilisation et la transparence, piliers de la gouvernance locale et de la démocratie participative.
        </p>
      </Hero>

      <ProgramSection>
        <div className="container">
          {programs.map((program, index) => (
            <ProgramCard key={index}>
              <div className="icon">{program.icon}</div>
              <h2>{program.title}</h2>
              <p>{program.description}</p>
              <div className="activities">
                <h3>Axes et activités principales :</h3>
                <ul>
                  {program.activities.map((activity, idx) => (
                    <li key={idx}>{activity}</li>
                  ))}
                </ul>
              </div>
            </ProgramCard>
          ))}
        </div>
      </ProgramSection>
    </ProgramsContainer>
  );
};

export default Programs;
